import { Slider, TextField, Typography } from "@mui/material";
import debounce from "debounce";
import { useCallback, useState } from "react";

interface SingleValueSliderProps {
  min?: number;
  max?: number;
  label?: string;
  onChange?: Function;
  disabled?: boolean;
}
export default function SingleValueSlider(props: SingleValueSliderProps) {
  const {
    max = 1,
    label = "Slider Label",
    onChange = () => {},
    disabled,
  } = props;

  const [requested, setRequested] = useState<number>(0.5);

  //eslint-disable-next-line
  const handleChange = useCallback(
    debounce((value: number) => {
      onChange(value);
    }, 1000),
    //eslint-disable-next-line
    []
  );

  return (
    <>
      <div
        className="horizontalCenter"
        style={{ columnGap: "20px", padding: "0px 10px" }}
      >
        <TextField
          disabled={disabled}
          id="outlined-basic"
          label="value"
          variant="outlined"
          size="small"
          sx={{
            width: "100px",
            paddingTop: "0px",
            paddingBottom: "0px",
            position: 0,
          }}
          value={requested}
          inputMode="numeric"
          InputProps={{
            type: "number",
            inputProps: {
              max: max,
              min: 0,
              step: 0.1,
            },
          }}
          onChange={(event) => {
            setRequested(parseFloat(event.target.value));
            handleChange(parseFloat(event.target.value));
          }}
        />
        <div style={{ width: "100%" }}>
          <Typography
            id="area-slider"
            gutterBottom
            sx={{
              fontSize: "0.9rem",
              textAlign: "center",
              lineHeight: "0.8rem",
            }}
          >
            {label}
          </Typography>

          <Slider
            disabled={disabled}
            aria-labelledby="area-slider"
            value={requested}
            onChange={(event: Event, newValue: number | number[]) => {
              handleChange(newValue as number);
              setRequested(newValue as number);
            }}
            valueLabelDisplay="auto"
            max={max}
            min={0}
            step={0.1}
            sx={{ paddingTop: "0px" }}
            // getAriaValueText={requested.toString()}
          />
        </div>
      </div>
    </>
  );
}
